import { format } from 'date-fns';
import service from '../../service/employeeResource';

function formatDateWithTimeZoneForSearch(dateAndTime) {
  let formattedDate = format(new Date(dateAndTime), "yyyy-MM-dd'T'HH:mm:ss");
  let addedTimeZone = formattedDate + getTimeZoneForSearch();
  return addedTimeZone;
}
function getTimeZoneForSearch() {
  let offset = new Date().getTimezoneOffset(),
    o = Math.abs(offset);
  let encodedOffset =
    (offset < 0 ? '+' : '-') +
    ('00' + Math.floor(o / 60)).slice(-2) +
    ':' +
    ('00' + (o % 60)).slice(-2);
  return encodedOffset;
}

const initalState = {
  allCardsOfEmployee: [],
  employees: [],
  employeesLoading: false,
  cardsOfEmployeeLoading: false,
  cardsOfEmployee: [],
  cardsOfEmployeePage: 0,
  cardsOfEmployeeSortModel: [],
  cardsOfEmployeePageCount: 0,
  allCardsOfEmployeeLoading: false,
};
export const createEmployeesStore = (set, get) => ({
  ...initalState,
  setCardsOfEmployeePage: (e) => set({ cardsOfEmployeePage: e }),
  setCardsOfEmployeeSortModel: (sortModel) =>
    set({ cardsOfEmployeeSortModel: sortModel }),
  fetchEmployees: async (data) => {
    set({ error: '' });
    try {
      set({ employeesLoading: true });
      if (data === '') {
        return;
      }
      const response = await service.getEmployeesWithSearchAll({ query: data });
      set({ employees: response?.data?.data });
    } catch (error) {
      set({ employees: [] });
    } finally {
      set({ employeesLoading: false });
    }
  },
  fetchCardsByEmployee: async (data) => {
    set({ error: '' });
    const sortModel = get().cardsOfEmployeeSortModel;
    const { field, sort } =
      sortModel.length > 0
        ? get().cardsOfEmployeeSortModel[0]
        : { field: 'id', sort: 'desc' };
    const { employeeId, isMobile, t0, t1 } = data;
    try {
      set({ cardsOfEmployeeLoading: true });
      const params = {
        size: isMobile ? 5 : 10,
        page: get().cardsOfEmployeePage,
        sort: `${field},${sort}`,
        t0: formatDateWithTimeZoneForSearch(t0),
        t1: formatDateWithTimeZoneForSearch(t1),
      };
      const result = await service.getCardEventsByEmployeeId(
        employeeId,
        params,
      );

      const data = result?.data?.data;
      const properties = result?.data?.properties;
      localizateData(data);
      set({
        cardsOfEmployeePageCount:
          properties?.totalPages === null || 0 ? 1 : properties.totalPages,
      });
      set({ cardsOfEmployee: data });
      if (data.length === 0) {
        get().setError('Kart bilgileri bulunamadı.');
      }
    } catch (error) {
      set({ cardsOfEmployee: [] });
      set({ error: 'Kart bilgileri getirilirken hata oluştu.' });
    } finally {
      set({ cardsOfEmployeeLoading: false });
    }
  },
  fetchAllCardsByEmployee: async (formstate) => {
    const params = {
      t0: formatDateWithTimeZoneForSearch(formstate.t0),
      t1: formatDateWithTimeZoneForSearch(formstate.t1),
    };
    try {
      const resultAll = await service.getAllCardEventByEmployeeId(
        formstate.employeeId,
        params,
      );
      const data = resultAll?.data?.data;
      set({ allCardsOfEmployee: localizateData(data) });
    } catch (error) {
      set({ allCardsOfEmployee: [] });
      console.log(error);
    } finally {
      set({ allCardsOfEmployeeLoading: false });
    }
  },
  resetEmployees: () => {
    set({
      employees: [],
      employeesLoading: false,
    });
  },
  resetCardsOfEmployee: () => {
    if (get().cardsOfEmployeePage !== 0) {
      set({
        cardsOfEmployee: [],
        allCardsOfEmployee: [],
        cardsOfEmployeeLoading: false,
        allCardsOfEmployeeLoading: false,
        allCardsOfEmployee: [],
        cardsOfEmployeePage: 0,
        cardsOfEmployeeSortModel: [],
        cardsOfEmployeePageCount: 0,
      });
    } else {
      set({
        cardsOfEmployee: [],
        allCardsOfEmployee: [],
        cardsOfEmployeeLoading: false,
        allCardsOfEmployeeLoading: false,
        allCardsOfEmployee: [],
      });
    }
  },
});
function localizateData(data) {
  for (let i = 0; i < data?.length; i++) {
    if (data[i].status === 'SUCCESSFUL') {
      let text = 'SUCCESSFUL';
      let result = text.replace('SUCCESSFUL', 'BAŞARILI');
      data[i].status = result;
    }

    if (data[i].status === 'UNSUCCESSFUL') {
      let text = 'UNSUCCESSFUL';
      let result = text.replace('UNSUCCESSFUL', 'BAŞARISIZ');
      data[i].status = result;
    }
  }
  return data;
}
